import React, { useEffect, useState } from 'react';
import { ArrowCounterClockwise, type Icon } from '@phosphor-icons/react';
import { BestaetigenDialog } from '../../../../../components/immobilien/ui';
import { useDlSeite } from '../DienstleisterSeitenKontext';

export const GLAS: React.CSSProperties = { background: 'var(--glass)' };
export const fehlerText = (e: unknown) => (e instanceof Error ? e.message : 'Unbekannter Fehler');
export const BEREICH_STIL: React.CSSProperties = {
  width: '100%', borderRadius: 15, padding: 14, border: 'none', resize: 'vertical', background: 'var(--bg)', boxShadow: 'inset 0 0 0 1px var(--line)',
  fontSize: 15, color: 'var(--ink)', outline: 'none', fontFamily: 'inherit',
};

/** Rückfrage bei ungespeicherten Änderungen (Escape, „Alle Widgets“). */
export function useVerlassen(geaendert: boolean): [boolean, (v: boolean) => void] {
  const { registriereVerlassen } = useDlSeite();
  const [verwerfen, setVerwerfen] = useState(false);
  useEffect(() => {
    registriereVerlassen(geaendert ? () => setVerwerfen(true) : null);
    return () => registriereVerlassen(null);
  }, [geaendert, registriereVerlassen]);
  return [verwerfen, setVerwerfen];
}

export function Verwerfen({ text, onAbbrechen }: { text: string; onAbbrechen: () => void }) {
  const { registriereVerlassen, schliessePanel } = useDlSeite();
  return (
    <BestaetigenDialog titel="Änderungen verwerfen?" text={text} bestaetigenLabel="Verwerfen" icon={ArrowCounterClockwise}
      onBestaetigen={() => { onAbbrechen(); registriereVerlassen(null); schliessePanel(); }} onAbbrechen={onAbbrechen} />
  );
}

export const Aktionslink = ({ href, icon: IconKomp, extern = false, children }: { href: string; icon: Icon; extern?: boolean; children: React.ReactNode }) => (
  <a href={href} {...(extern ? { target: '_blank', rel: 'noopener noreferrer' } : {})} className="immo-hover-flaeche inline-flex items-center"
    style={{ height: 44, padding: '0 16px', gap: 7, borderRadius: 22, background: 'var(--fill2)', color: 'var(--ink)', fontSize: 13, fontWeight: 700, textDecoration: 'none' }}>
    <IconKomp weight="bold" size={14} />{children}
  </a>
);

export const telHref = (s: string) => `tel:${s.replace(/[^\d+]/g, '')}`;
